import { generateForm } from "@rjsf/chakra-ui";
import { FormProps } from "@rjsf/core";
import validator from "@rjsf/validator-ajv8";

import { useMainForm } from "../hooks/use-main-form";
import { MainFormData } from "../types/main-form-data";

const Form = generateForm<MainFormData>();

export const MainForm = ({
  children,
  ...rest
}: Omit<FormProps<MainFormData>, "schema" | "uiSchema" | "validator">) => {
  const { isLoading, schema, uiSchema } = useMainForm();

  if (isLoading) return null;

  return (
    <Form
      className="full-height-form"
      schema={schema}
      uiSchema={{
        ...uiSchema,
        "ui:title": "", // This hides the schema title
      }}
      validator={validator}
      {...rest}
    >
      {children}
    </Form>
  );
};
